import { render, staticRenderFns } from "./placard_manuscript_draft.vue?vue&type=template&id=46d930f4&scoped=true"
import script from "./placard_manuscript_draft.vue?vue&type=script&lang=js"
export * from "./placard_manuscript_draft.vue?vue&type=script&lang=js"
import style0 from "./placard_manuscript_draft.vue?vue&type=style&index=0&id=46d930f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d930f4",
  null
  
)

export default component.exports